/**
 * 通用 fetch 下载函数，支持自动提取 Content-Disposition 文件名
 */
export async function downloadFile({
    url,
    method = 'POST',
    headers = {},
    body = {},
    withCredentials = true,
    filename: customFilename
  }: {
    url: string;
    method?: 'POST' | 'GET';
    headers?: Record<string, string>;
    body?: any;
    withCredentials?: boolean;
    filename?: string;
  }) {
    try {
      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json, text/plain, */*',
          ...headers
        },
        credentials: withCredentials ? 'include' : 'same-origin',
        body: method === 'GET' ? undefined : JSON.stringify(body)
      });
  
      if (!res.ok) throw new Error(`下载失败，状态码：${res.status}`);
  
      // 从 Content-Disposition 中获取文件名
      const disposition = res.headers.get('content-disposition');
      let filename = customFilename || 'downloaded-file';
      if (!customFilename && disposition) {
        const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
        if (match) {
          filename = decodeURIComponent(match[1]);
        }
      }
  
      const blob = await res.blob();
      const urlBlob = window.URL.createObjectURL(blob);
  
      const a = document.createElement('a');
      a.href = urlBlob;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      console.error('❌ 文件下载失败：', error);
    }
  }

  // 获取文件后缀
  export function getFileExtension(filename: string, toLowerCase = true) {
    const ext = filename.split('.').pop() || '';
    return toLowerCase ? ext.toLowerCase() : ext;
  }
